import React, { Component } from 'react';
import { Input, Form, Row, Col, Modal, DatePicker, message, Select, Button, Upload, Icon, InputNumber } from 'antd';
import { Message } from 'semantic-ui-react';
import moment from 'moment';

import { ACTION_STATUS } from '../../../../utils/ActionStatus';
import { localStorageClient } from '../../../../utils/localStorageClient';
import BaseUrlConfig from '../../../../net/BaseUrlConfig';
import UrlConfig from '../../../../net/UrlConfig';

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const Option = Select.Option;
const CPT_CATEGORY_OPTIONS = [
  'Regulated Activities Related',
  'Ethics/Compliance',
  'Regulatory Compliance',
  'Others',
];

const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 14 },
};

class AddOrEditCptModalDialog extends Component {
  componentDidUpdate() {
    const { addOrEditCptActionStatus, addOrEditCptModal } = this.props;

    if (addOrEditCptActionStatus === ACTION_STATUS.SUCCESS) {
      const actionText = addOrEditCptModal.mode === 'ADD'
        ? 'Add'
        : addOrEditCptModal.mode === 'COPY'
          ? 'Copy'
          : 'Edit';
      message.success(`${actionText} CPT record succeeded`);
      this.props.initAddOrEditCptActionStatus();
      this.props.resetAddOrEditCptModal();
      this.refreshQuery();
    }

    if (addOrEditCptActionStatus === ACTION_STATUS.ERROR) {
      this.props.initAddOrEditCptActionStatus();
    }
  }

  refreshQuery = () => {
    const { year } = this.props.cptQueryFields;
    this.props.loadCptInfo({ employee: localStorageClient.getUserName(), year });
  };

  onInputChange = ({ name, value }) => {
    this.props.addOrEditCptChangeInput({ name, value });
  };

  attachmentHandleChange = info => {
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    this.onInputChange({ name: 'fileList', value: fileList });

    if (fileList.length > 0 && fileList[0].response && fileList[0].response.data) {
      this.onInputChange({ name: 'attachment', value: fileList[0].response.data.fileNameWithTimeStamp });
      this.onInputChange({ name: 'attachmentOriginName', value: fileList[0].response.data.originalFileName });
    }
    if (fileList.length === 0) {
      this.onInputChange({ name: 'attachment', value: '' });
      this.onInputChange({ name: 'attachmentOriginName', value: '' });
    }
  };

  submitAddOrEditCpt = () => {
    const { fields, mode } = this.props.addOrEditCptModal;
    this.props.form.validateFields(err => {
      if (!err) {
        this.props.addOrEditCpt({
          id: fields.id,
          employee: fields.employee || localStorageClient.getUserName(),
          eventDate: fields.eventDate,
          eventOrganizer: fields.eventOrganizer,
          eventName: fields.eventName,
          cptCategory: fields.cptCategory,
          cptHours: fields.cptHours,
          attachment: fields.attachment,
          attachmentOriginName: fields.attachmentOriginName,
          remarks: fields.remarks,
          complianceApproval: fields.complianceApproval,
          mode,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { addOrEditCptModal, addOrEditCptActionStatus } = this.props;
    const { isOpened, mode, respErrMsg, fields } = addOrEditCptModal;
    const isSubmitLoading = addOrEditCptActionStatus === ACTION_STATUS.LOGINING;

    const cptCategoryOptionNodes = CPT_CATEGORY_OPTIONS.map(item => (
      <Option key={item} value={item}>{item}</Option>
    ));

    const attachmentUrl = fields.attachment
      ? `${BaseUrlConfig.api.REST_URL}${BaseUrlConfig.api.API_VERSION}${UrlConfig.DOWNLOAD_CPT_ATTACHMENT}/${fields.attachment}`
      : '';
    const uploadAttachmentUrl = `${BaseUrlConfig.api.REST_URL}${BaseUrlConfig.api.API_VERSION}${UrlConfig.UPLOAD_CPT_ATTACHMENT}`;
    const modalTitle = mode === 'ADD' ? 'Add CPT' : mode === 'COPY' ? 'Copy CPT' : 'Edit CPT';

    return (
      <Modal
        title={modalTitle}
        centered
        width={1000}
        visible={isOpened}
        destroyOnClose={true}
        maskClosable={false}
        onCancel={this.props.resetAddOrEditCptModal}
        footer={[
          <Button key="close" onClick={this.props.resetAddOrEditCptModal}>
            Close
          </Button>,
          <Button key="submit" type="primary" loading={isSubmitLoading} onClick={this.submitAddOrEditCpt}>
            Add Record
          </Button>,
        ]}
      >
        <Form layout="horizontal">
          <Row gutter={24}>
            <Col span={12}>
              <FormItem {...formItemLayout} label="Employee">
                <Input value={fields.employee || localStorageClient.getUserName()} disabled />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem {...formItemLayout} label="Event Date">
                {getFieldDecorator('eventDate', {
                  initialValue: fields.eventDate ? moment(fields.eventDate) : null,
                })(
                  <DatePicker
                    style={{ width: '100%' }}
                    onChange={(date, dateString) => this.onInputChange({ name: 'eventDate', value: dateString })}
                  />
                )}
              </FormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={12}>
              <FormItem {...formItemLayout} label="Event Organizer">
                {getFieldDecorator('eventOrganizer', {
                  initialValue: fields.eventOrganizer,
                })(
                  <Input onChange={e => this.onInputChange({ name: 'eventOrganizer', value: e.target.value })} />
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem {...formItemLayout} label="Event Name">
                {getFieldDecorator('eventName', {
                  initialValue: fields.eventName,
                })(
                  <Input onChange={e => this.onInputChange({ name: 'eventName', value: e.target.value })} />
                )}
              </FormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={12}>
              <FormItem {...formItemLayout} label="CPT Category">
                {getFieldDecorator('cptCategory', {
                  initialValue: fields.cptCategory || undefined,
                })(
                  <Select
                    allowClear
                    placeholder="Select CPT Category"
                    onChange={value => this.onInputChange({ name: 'cptCategory', value })}
                  >
                    {cptCategoryOptionNodes}
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem {...formItemLayout} label="CPT Hours">
                {getFieldDecorator('cptHours', {
                  initialValue: fields.cptHours === '' ? undefined : fields.cptHours,
                })(
                  <InputNumber
                    min={0}
                    step={0.5}
                    style={{ width: '100%' }}
                    onChange={value => this.onInputChange({ name: 'cptHours', value })}
                  />
                )}
              </FormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={12}>
              <FormItem {...formItemLayout} label="Attachment">
                <Upload
                  name="file"
                  withCredentials={true}
                  multiple={false}
                  fileList={fields.fileList}
                  action={uploadAttachmentUrl}
                  onChange={this.attachmentHandleChange}
                >
                  <Button style={{ width: '100%' }}>
                    <Icon type="upload" /> Upload
                  </Button>
                </Upload>
                {attachmentUrl ? (
                  <div style={{ marginTop: 8 }}>
                    <a href={attachmentUrl} target="_blank" rel="noopener noreferrer">
                      {fields.attachmentOriginName || fields.attachment}
                    </a>
                  </div>
                ) : null}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem {...formItemLayout} label="Approval Status">
                {getFieldDecorator('complianceApproval', {
                  initialValue: fields.complianceApproval,
                })(
                  <Input disabled />
                )}
              </FormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={24}>
              <FormItem labelCol={{ span: 4 }} wrapperCol={{ span: 18 }} label="Note">
                {getFieldDecorator('remarks', {
                  initialValue: fields.remarks,
                })(
                  <TextArea rows={4} onChange={e => this.onInputChange({ name: 'remarks', value: e.target.value })} />
                )}
              </FormItem>
            </Col>
          </Row>
        </Form>
        {!!respErrMsg && (
          <Message negative>
            <Message.Header>Response Error Message</Message.Header>
            <p>{respErrMsg}</p>
          </Message>
        )}
      </Modal>
    );
  }
}

const AddOrEditCptModalDialogForm = Form.create({ name: 'AddOrEditCptModalDialog' })(AddOrEditCptModalDialog);

export default AddOrEditCptModalDialogForm;
